import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function OutsourcingIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M20 2H5C4.44772 2 4 2.44771 4 3V22C4 22.5523 4.44772 23 5 23H15.2305C16.0758 23 16.8818 22.6434 17.4503 22.018L20.2198 18.9716C20.7218 18.4194 21 17.6999 21 16.9536V3C21 2.44771 20.5523 2 20 2Z" fill={props.fill} stroke="#BCBBD0" strokeWidth="2" />
			<path opacity="0.5" d="M15 24V19C15 17.8954 15.8954 17 17 17H22" stroke="white" strokeWidth="2" />
			<mask id="path-3-inside-1" fill="white">
				<path d="M9 9C9 8.44772 9.44772 8 10 8H15C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H10C9.44772 10 9 9.55228 9 9Z" />
			</mask>
			<path d="M9 9C9 8.44772 9.44772 8 10 8H15C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H10C9.44772 10 9 9.55228 9 9Z" fill="white" />
			<path d="M10 9H15V7H10V9ZM15 9H10V11H15V9ZM10 9H10H8C8 10.1046 8.89543 11 10 11V9ZM15 9V11C16.1046 11 17 10.1046 17 9H15ZM15 9H17C17 7.89543 16.1046 7 15 7V9ZM10 7C8.89543 7 8 7.89543 8 9H10V7Z" fill="white" mask="url(#path-3-inside-1)" />
			<mask id="path-5-inside-2" fill="white">
				<path d="M9 13C9 12.4477 9.44772 12 10 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H10C9.44772 14 9 13.5523 9 13Z" />
			</mask>
			<path d="M9 13C9 12.4477 9.44772 12 10 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H10C9.44772 14 9 13.5523 9 13Z" fill="white" />
			<path d="M10 13H11V11H10V13ZM11 13H10V15H11V13ZM10 13H10H8C8 14.1046 8.89543 15 10 15V13ZM11 13V15C12.1046 15 13 14.1046 13 13H11ZM11 13H13C13 11.8954 12.1046 11 11 11V13ZM10 11C8.89543 11 8 11.8954 8 13H10V11Z" fill="white" mask="url(#path-5-inside-2)" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<OutsourcingIcon fill={props.fill} />
		</div>
	);
}